export const NAV_LINKS = [
  { label: 'Pricing', href: '#pricing' },
  { label: 'FAQ', href: '#faq' },
];

export const HERO_CONTENT = {
  title1: "Your Second Brain,",
  title2: "Built Into Your",
  titleAccent: "Browser.",
  description: "Karpture captures everything you copy—searchable, organized, and accessible across every session. Never lose a breakthrough idea to a closed tab again.",
  ctaUrl: "https://chromewebstore.google.com/detail/hchfmlpajccgjkabcnfepjfikiopghlo",
  ctaText: "Add to Chrome — Free",
  heroImage: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&q=80&w=1000",
};

export const VIDEO_CONTENT = {
  subtitle: "The Browser Extension That Remembers Everything You Copy",
  title: "Capture, Search, Recall. Like a Pro.",
  description: "See how Karpture builds your personal history in the background while you work. No manual saving, no forgotten ideas.",
  videoUrl: "https://www.youtube.com/embed/SlDR58warys?playsinline=1&modestbranding=1&rel=0",
};

export const FEATURES_CONTENT = {
  subtitle: "STOP SEARCHING, START RECALLING.",
  title: "Most tools help you work faster; Karpture helps you work smarter.",
  image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&q=80&w=800",
  features: [
    {
      title: "Unlimited Memory",
      description: "Pro users never lose a thing. Free users enjoy a 90-day rolling window.",
      icon: "Brain",
    },
    {
      title: "Search Across Time",
      description: "Find anything you've ever copied by keyword, date, source URL, or context.",
      icon: "Search",
    },
    {
      title: "Session Timeline",
      description: "Visualize your work history. See exactly what you copied and when.",
      icon: "History",
    },
  ],
  testimonial: {
    text: "Every snippet of text you copy is automatically captured, timestamped, and indexed. Your best thinking is now archived and ready for instant retrieval.",
    author: "Karpture v2",
  }
};

export const PRIVACY_CONTENT = {
  subtitle: "PRIVACY FIRST",
  title: "Your Data, Strictly On-Device.",
  description: "Karpture is built on the principle of local-first dominance. Your memory system lives on your hard drive, protected by native security.",
  features: [
    "Zero-Knowledge Architecture: We never see what you copy.",
    "No Cloud Syncing: No data mining, no third-party servers.",
    "Styled Journal Export: One-click Memoirs.",
  ]
};

export const PRICING_CONTENT = {
  subtitle: "SIMPLE, TRANSPARENT PRICING",
  title: "Choose the depth of your second brain.",
  plans: [
    {
      name: "Free Forever",
      price: "0",
      description: "Perfect for casual users who need a short-term memory boost.",
      features: [
        "90-day memory history",
        "Basic search functionality",
        "Core capture engine",
        "Pin favorite snippets",
      ],
      buttonText: "Get Started for Free",
      buttonUrl: "https://chromewebstore.google.com/detail/hchfmlpajccgjkabcnfepjfikiopghlo",
      accent: false,
    },
    {
      name: "Pro Access",
      price: "5",
      description: "Infinite recall for serious thinkers, writers, and builders.",
      features: [
        "Unlimited memory history",
        "Full search across all time",
        "Advanced context recall",
        "Export all memories",
        "Focus Mode & Ignore Sources",
      ],
      buttonText: "Upgrade with Polar.sh",
      buttonUrl: "https://buy.polar.sh/polar_cl_HDV1vjg1vzsYsGx6F1Unl0ucGs33BxHonQcOx4WeBfO",
      accent: true,
    },
  ],
};

export const CTA_CONTENT = {
  title: "Simple to Set Up. Impossible to Forget.",
  description: "Install Extension: Add Karpture to your browser in one click. No account required to get started.",
  ctaUrl: "https://chromewebstore.google.com/detail/hchfmlpajccgjkabcnfepjfikiopghlo",
};

export const FOOTER_CONTENT = {
  company: ["About Karpture", "Blog", "Features", "Changelog"],
  product: ["Browser Extension", "Chrome Web Store", "Pricing", "Updates"],
  resources: ["Help Center", "Privacy Policy", "Terms of Service", "Export Tools"],
  extras: ["Newsletter", "Partner Program"],
};

export const COPYRIGHT_TEXT = "© 2026 Karpture. Work Memory System v2.0.0. Made with intent by Thosyn Pax.";
